import * as React from 'react';
import styled from 'styled-components/macro';
import { Link, useParams } from 'react-router-dom';
import { spacing } from '@mui/system';
import {
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Box,
  Link as MuiLink,
  Container
} from '@mui/material';
import { PATH_DASHBOARD } from '../../../constants';
import { DashboardForm } from '../../../components/dashboardList/form/DashboardForm';
import { useCallback } from 'react';
import { dashboardAPI } from '../../../services/DashboardsService';

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const CreateBrandDashboard: React.FC = () => {
  const { id = '' } = useParams();

  const [
    createDashboard,
    { isSuccess: isSuccessCreate, error: createError, isLoading: isLoadingCreate }
  ] = dashboardAPI.useCreateDashboardMutation();

  const handleRequestCreate = useCallback(
    (form: FormData) => {
      createDashboard(form);
    },
    [createDashboard]
  );

  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 5 }}>
        <Typography variant="h3" gutterBottom>
          Add Brand Dashboard
        </Typography>
        <Breadcrumbs>
          <MuiLink component={Link} to={PATH_DASHBOARD.ROOT}>
            Dashboard admin
          </MuiLink>
          <MuiLink component={Link} to={PATH_DASHBOARD.LIST}>
            List
          </MuiLink>
          <Typography>New dashboard</Typography>
        </Breadcrumbs>
        <DashboardForm
          dashboardId={id}
          handleRequest={handleRequestCreate}
          isSuccessRequest={isSuccessCreate}
          error={createError}
          isLoadingRequest={isLoadingCreate}
          route={PATH_DASHBOARD.LIST}
        />
      </Box>
    </Container>
  );
};

export default CreateBrandDashboard;
